<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Evaluations/MyTeam/Grid'

    export default {
        components: {
            Grid,
        }
    }
</script>